/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

export function simpleFilter(text: string | undefined, filter: string): boolean {
  if (!text) {
    return false;
  }
  return text?.toLowerCase().includes(filter.toLowerCase());
}
